import React, { useState,useEffect } from "react";
import { toast } from "react-toastify";

const SourceTab = ({updateReviewTabData,reviewTabData}) => {
    const [amazonUrl, setAmazonUrl] = useState(reviewTabData.business_name || "");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Sync with latest business_name from props
    useEffect(() => {
        setAmazonUrl(reviewTabData.business_name || "");
    }, [reviewTabData.business_name]);

    // State to manage the submission status
    const submitReviewForm = async (e) => {
        e.preventDefault();

        if (!amazonUrl.trim()) {
            toast.error("Please enter an Amazon product ASIN Number.");
            return;
        }
        updateReviewTabData("business_name", amazonUrl); 
        setIsSubmitting(true);
        // Simulate API delay
        setTimeout(() => {
            setIsSubmitting(false);
        }, 1500); 
        
    };

    return (
        <div className="side-baar-inner-source">
            <span>Source</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        placeholder="Enter Amazon Product ASIN..."
                        value={amazonUrl}
                        onChange={(e) => setAmazonUrl(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={submitReviewForm}
                        disabled={isSubmitting}
                        className={isSubmitting ? "disabled" : ""}
                    >
                        {isSubmitting ? "Searching..." : "Search"}
                    </button>
                </div>
            </div>

            <p>
                Enter your Amazon product ASIN Number to display your reviews, for example:{" "}
                <a
                    href="https://www.amazon.com/Noodle-Bones-Day-Jonathan-Graziano/dp/1665927100"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    1665927100
                </a>
            </p>
            <div className="supported-domains"> 
                Supported domains:
                <ul>
                    <li>.com (USA)</li>
                    <li>.ca (Canada)</li>
                    <li>.com.au (Australia)</li>
                    <li>.co.jp (Japan)</li>
                    <li>.co.uk (United Kingdom)</li>
                    <li>.de (Germany)</li>
                    <li>.es (Spain)</li>
                    <li>.fr (France)</li>
                    <li>.in (India)</li>
                    <li>.it (Italy)</li>
                </ul>
            </div>
        </div>
    );
};

export default SourceTab;
